import React, { useEffect, useRef, useState } from "react";
import backBtn from "../../assets/images/backBtn.svg";
import backBtnMobile from "../../assets/images/backBtnMobile.svg";
import { useNavigate } from "react-router-dom";
import ReactSignatureCanvas from "react-signature-canvas";
import { acceptAgreementAction, acceptAgreementHandler } from "../../redux/action/acceptAgreement";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../Loder/loader";
import { getShowAgreementAction, getShowAgreementHandler } from "../../redux/action/getShowAgreement";
import { useCommonMessage } from "../../common/CommonMessage";
import { useTranslation } from "react-i18next";
import { getItem } from "../../common/localStorage";
import NoAnyDocs from "../noAnyDocs/NoAnyDocs";
import { getNotificationsCountsAction } from "../../redux/action/getNotificationsCounts";

const Esign = () => {
  const [isSigned, setIsSigned] = useState(false);
  const [showNoDocsError, setShowNoDocsError] = useState(false);

const { t } = useTranslation();
  const navigate = useNavigate();
  const messageApi = useCommonMessage();
  const dispatch = useDispatch();
  const acceptAgreementSelctor = useSelector((state) => state?.acceptAgreement);
  const getShowAgreementSelector = useSelector(
    (state) => state?.getShowAgreementMain
  );

  const getLoginId = getItem("adminId");

  useEffect(() => {
    dispatch(getShowAgreementHandler());
  }, []);

  const signatureRef = useRef(null);

  const clear = () => {
    signatureRef.current.clear();
    setIsSigned(false);
  };

  // useEffect(() => {
  //   if (acceptAgreementSelctor?.data?.statusCode === 200) {
  //     navigate("/pdf-review",{state:acceptAgreementSelctor});
  //   }
  // }, [acceptAgreementSelctor]);

  useEffect(() => {
    if(getShowAgreementSelector?.message){
      setShowNoDocsError(true);
    }
  }, [getShowAgreementSelector]);

  const handleCloseErrorModal = () => {
    setShowNoDocsError(false);
    navigate("/dashboard");
    dispatch(getShowAgreementAction.getShowAgreementInfoReset());
    dispatch(acceptAgreementAction.acceptAgreementInfoReset());
  };

  const save = () => {
    if (signatureRef.current.isEmpty()) {
      return;
    }

    const dataURL = signatureRef.current.toDataURL();
    let payload = {
      userId: getLoginId,
      agreementVersion: getShowAgreementSelector?.data?.data?.agreementVersion,
      deviceId: "", 
      platform: "", 
      location: "", 
      base64Image: dataURL,
    };

    dispatch(acceptAgreementHandler(payload));
  };

  const handleSignature = () => {
    if (signatureRef.current && !signatureRef.current.isEmpty()) {
      setIsSigned(true);
    }
  };

  useEffect(() => {
    if (acceptAgreementSelctor?.data?.statusCode === 200) {
      messageApi.open({
        type: "success",
        content: acceptAgreementSelctor?.data?.message,
      });
      navigate("/pdf-review",{state:acceptAgreementSelctor});
      dispatch(acceptAgreementAction.acceptAgreementInfoReset());
      dispatch(getShowAgreementAction.getShowAgreementInfoReset());
      dispatch(getNotificationsCountsAction.getNotificationsCountReset());
    }else if(acceptAgreementSelctor?.message){
      setShowNoDocsError(true);
      dispatch(getShowAgreementAction.getShowAgreementInfoReset());
    dispatch(acceptAgreementAction.acceptAgreementInfoReset());
    }
  }, [acceptAgreementSelctor]);

  console.log(acceptAgreementSelctor,"acceptAgreementSelctor");

  console.log(getShowAgreementSelector,"getShowAgreementSelector");

  return (
    <>
      {(acceptAgreementSelctor?.isLoading || getShowAgreementSelector?.isLoading) && (
        <Loader loaderTransForm="loaderTransForm" />
      )}
      <div className="commonHeader">
        <div className="container">
          <div className="headerBg">
            <img
              src={backBtn}
              onClick={() => navigate("/consent")}
              className="cursor-pointer backBtn"
              alt=""
            />
            <img
              src={backBtnMobile}
              onClick={() => navigate("/consent")}
              className="cursor-pointer backBtnMobile"
              alt=""
            />
            <h2>{t("eSign - Document")}</h2>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="py-50 mobileSignMargin">
          <h2 className="mb-20">{t("Draw your signature on the box below")}</h2>
          <ReactSignatureCanvas
            ref={signatureRef}
            penColor="black"
            canvasProps={{ className: "signature-canvas mb-20" }}
            onEnd={handleSignature}
          />
          <div className="text-end mb-40 cursor-pointer" onClick={clear}>
            {t("Clear")}
          </div>
          <div className="mx420 mx-auto">
            <button
              onClick={save}
              disabled={!isSigned} 
              // className="primaryButton w-100 cursor-pointer disable  activeted"
              className={`primaryButton w-100 cursor-pointer ${!isSigned ? "disable" : "activated"}`}
            >
              {t("Continue")}
            </button>
          </div>
        </div>
      </div>
      {showNoDocsError && (
        <NoAnyDocs showNoDocsError={showNoDocsError} handleCloseErrorModal={handleCloseErrorModal} />
      )}
    </>
  );
};

export default Esign;
